exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".qtc-wrapper{font-size:16px !important;overflow-x:hidden}", ""]);

// exports
